import React, { useState, useEffect } from "react";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Loader from "../../components/loader";
import Table from "../../components/table";

const Processor = ({
  getPaymentProcessorslistConnect,
  updatePaymentProcessorDetailsConnect,
  isAdminUserConnect,
  funnelStep,
}) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isUnauthorized, setIsUnauthorized] = useState(false);

  const { email } = funnelStep || {};

  useEffect(() => {
    setIsLoading(true);
    let userDetails = {
      adminUserName: email,
    };
    isAdminUserConnect(userDetails)
      .then((response) => {
        if (!!response && response == true) {
          const initialColumns = [
            { Header: "Processor ID", accessor: "processorId" },
            { Header: "Processor Name", accessor: "name" },
            { Header: "Processor Key", accessor: "processorKey" },
            { Header: "Max Threshold", accessor: "maxThreshold" },
            { Header: "Traffic", accessor: "trafficPercentage" },
          ];
          setColumns(initialColumns);
          getPaymentProcessorslistConnect()
            .then((response) => {
              if (!!response) {
                const sortedData = response.sort(
                  (a, b) => a.processorId - b.processorId
                );
                setData(sortedData);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              console.error("getPaymentProcessorslistConnect failed", error);
            });
        } else {
          setIsUnauthorized(true);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("getPaymentProcessorslistConnect failed", error);
      });
  }, []);

  const handleSave = () => {
    setIsLoading(true);
    updatePaymentProcessorDetailsConnect(data)
      .then((response) => {
        if (response) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("updatePaymentProcessorDetailsConnect failed", error);
        setIsLoading(false);
      });
  };

  const handleTrafficPercentageChange = (rowIndex, value) => {
    const updatedData = data.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, trafficPercentage: value };
      }
      return row;
    });
    setData(updatedData);
  };

  return (
    <div>
      <Header />
      <Loader isLoading={isLoading} />
      <div className="container mx-auto p-4">
        {isUnauthorized ? ( // Conditional rendering for unauthorized user
          <div
            className="border-4 border-red-700 font-bold text-red-700 text-center flex flex-col items-center justify-center"
            style={{
              height: "200px",
              width: "300px",
              margin: "auto",
              marginTop: "20vh",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 mb-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              style={{ color: "#FFD700" }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.29 3.86L1.82 18c-.78 1.35.2 3 1.71 3h16.94c1.51 0 2.49-1.65 1.71-3l-8.47-14.14a2 2 0 00-3.42 0zM12 9v4m0 4h.01"
              />
            </svg>
            Shoot!! You do not have access.
          </div>
        ) : (
          <>
            <h1 className="text-2xl font-bold mb-4">Load-Balancer Table</h1>
            <Table
              columns={columns}
              data={data}
              onTrafficPercentageChange={handleTrafficPercentageChange}
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={handleSave}
                className="flex justify-center items-center h-[50px] border border-transparent rounded-full shadow-sm text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 px-4 py-2"
              >
                Save
              </button>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Processor;
